import type { components } from "@/api/types";

type RequestStatus = components["schemas"]["RequestStatus"];

/**
 * Ключи кэша в одном месте. Разъехавшийся ключ не ломает сборку — он просто
 * перестаёт инвалидироваться, и экран показывает заявку, обработанную минуту
 * назад, как ждущую обработки.
 *
 * Матрица инвалидации после мутаций:
 *   deposit approve/reject   → deposits, dashboard, audit, user(id)
 *   withdrawal any           → withdrawals, dashboard, audit, user(id)
 *   balance adjust / block   → user(id), users, dashboard, audit
 *   robot create/update      → robots, robot(id), audit
 *   accrual roll / manual    → dashboard, accrualHistory, audit
 *   settings patch           → settings, audit
 *   admins create/update     → admins, audit
 *   comment publish/hide/delete/reply → comments, comment(id), dashboard, audit
 */
export const qk = {
  dashboard: () => ["dashboard"] as const,

  users: (query: string, blocked: boolean | null) =>
    ["users", query, blocked ?? "any"] as const,
  user: (id: number) => ["users", "detail", id] as const,
  userTransactions: (id: number) => ["users", "detail", id, "transactions"] as const,

  robots: () => ["robots"] as const,
  robot: (id: number) => ["robots", "detail", id] as const,
  robotPreview: (params: Record<string, string>) => ["robots", "preview", params] as const,
  robotAnalytics: (id: number, period: string) =>
    ["robots", "detail", id, "analytics", period] as const,

  deposits: (statuses: RequestStatus[]) => ["deposits", statuses.join(",")] as const,
  withdrawals: (statuses: RequestStatus[]) => ["withdrawals", statuses.join(",")] as const,

  accrualHistory: (userId: number | null) => ["accruals", "history", userId ?? "none"] as const,

  // Фильтры в ключе целиком: очередь модерации листается по статусам,
  // роботу и признаку жалоб, и общий ключ показывал бы чужую выборку.
  comments: (filters: Record<string, unknown>) => ["comments", filters] as const,
  comment: (id: number) => ["comments", "detail", id] as const,

  settings: () => ["settings"] as const,
  audit: (filters: Record<string, unknown>) => ["audit", filters] as const,
  admins: () => ["admins"] as const,
} as const;
